import { ChevronRight } from '@velocity-exchange/icons';
import MarketIcon from 'src/components/Utils/MarketIcon';
import PresetTag from 'src/components/Tags/PresetTag';

export const DepositFromOtherSourcesContent = () => (
	<>
		<PresetTag preset="new" />

		<span className="typo-label-sm">Deposit from other sources</span>
		<div className="flex flex-1 items-center justify-end gap-sm">
			<div className="flex items-center">
				<MarketIcon marketSymbol="BTC" className="z-[1] size-lg" />
				<MarketIcon marketSymbol="ETH" className="z-[2] -ml-1 size-lg" />
				<MarketIcon marketSymbol="SOL" className="z-[3] -ml-1 size-lg" />
				<MarketIcon marketSymbol="BNB" className="z-[4] -ml-1 size-lg" />
				<MarketIcon marketSymbol="HYPE" className="z-[5] -ml-1 size-lg" />
				<div className="ml-px typo-body-xs">+</div>
			</div>
			<ChevronRight size={16} className="text-text-secondary" />
		</div>
	</>
);
